import React from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import {toggleLoading} from "../../redux/reducers/utils";
import './UnknownError.scss';


function UnknownError(props) {
  props.toggleLoading(false);
  return <div className="text-white unknown-error-container">
    <p className="bottom-spacer-large top-spacer-very-large huge-text">Fidelius encountered an error while performing that action.</p>
    <p className="text-xl bottom-spacer-medium">We apologize for the inconvenience and have notified our engineering team of the issue.</p>
    <p className="text-xl">If you need assistance, please contact us at 'support@fideliusvaults.com' or start a chat session.</p>
  </div>
}

export default compose(
  connect(
    null,
    { toggleLoading }
  )
)(UnknownError);

